<template lang="pug">
  b-modal(
    v-model="show",
    header-class="lmm-common-popup-header",
    :title="dialog.context.title"
    @shown="focusIn",
    no-close-on-backdrop)
    div(@keyup.enter="submit")
      div.context.mb-2(v-html="$t(dialog.context.path, dialog.context.args)")
      div.input-wrap(v-if="!dialog.withoutInput")
        div.limit(v-if="dialog.limit")
          span(:class="{overlimit: value.length > dialog.limit}") {{value.length}}
          | /
          span {{dialog.limit}}
        b-form-textarea(
          v-if="dialog.textarea",
          ref="textarea",
          v-model="value",
          :placeholder="dialog.placeholder",
          :rows="3",
          :max-rows="6")
        b-form-input(
          v-else
          ref="input"
          v-model="value",
          :placeholder="$t(dialog.placeholder)")
    template(slot="modal-footer", class="w-100")
      b-btn(
        v-if="!dialog.withoutCancel",
        :size="dialog.submit.size",
        @click="cancel") {{$t('cancel')}}
      b-btn(
        :size="dialog.submit.size",
        :variant="dialog.submit.color",
        :disabled="dialog.submitDisabled || (dialog.limit && value.length > dialog.limit)",
        @click="submit", v-t="dialog.submit.text")
</template>

<script>
import _ from 'lodash'

const defaultValues = {
  size: 'lg',
  title: '',
  context: '',
  submit: {
    size: 'sm',
    text: 'submit',
    color: 'secondary'
  },
  value: '',
  limit: null,
  placeholder: '',
  textarea: false,
  nullable: false,
  withoutInput: false,
  withoutCancel: false
}

let disabled = false

export default {
  name: 'confirm-dialog',
  methods: {
    focusIn () {
      disabled = false
      if (this.dialog.withoutInput) return
      if (this.dialog.textarea) setTimeout(() => (this.$refs.textarea.focus()), 600)
      else setTimeout(() => (this.$refs.input.focus()), 600)
    },
    submit () {
      if (disabled) return
      disabled = true
      if (this.dialog.withoutInput === false && !this.value && !this.dialog.nullable) {
        this.$awn.warning(this.$t('no_input_data'))
        disabled = false
        return
      }
      this.cb('submit', this.value)
      this.value = ''
      this.show = false
    },
    cancel () {
      this.cb('cancel')
      this.value = ''
      this.show = false
    },
  },
  created () {
    this.dialog = defaultValues
    this.AppState.$on('show-confirm-dialog', (data, cb) => {
      this.dialog = _.assignIn({}, defaultValues, data)
      if (data.value != null) this.value = data.value
      if (typeof cb === 'function') this.cb = cb      
      this.show = true
    })
  },
  data () {
    return {
      show: false,
      dialog: {},
      value: '',
      cb () {}
    }
  }
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>
<style lang="scss" scoped>
.limit {
  text-align: right;
}
.overlimit {
  color: red;
}


::v-deep .modal-header {
  background-color: #FAFAFA !important;
  padding: 1rem 1rem 0.75rem 1rem;
  h5 {
    font-size: 1.1rem;
    font-weight: 550;
  }
}

::v-deep .modal-footer {
  border: none;
  padding: 0 1rem 1rem 1rem
}

.btn-primary {
  color: black;
  min-width: 55px;
  &:hover {
    color: black;
  }
  &:active{
    color: black;
  }
}

.btn-secondary {
  color: #6F6F6F !important;
  background-color: #FFFFFF;
  font-weight: 400;
  min-width: 55px;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.context {
  font-size: 0.9rem;
  color: #545B64;
}
</style>
